import React, { useRef,useState,useEffect, useCallback } from 'react';
import Button from '@mui/material/Button';
import { useHistory } from "react-router-dom";
import useStyles, { getMuiTheme } from "./styles";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { pathOr, isNil, isEmpty } from "ramda";
import { useDispatch } from "react-redux";
// import { saveAs } from "file-saver";
// import PDFDocument from './pdfDocument';
// import { PDFViewer } from '@react-pdf/renderer';
// import { useReactToPrint } from 'react-to-print';
// import Printer, { print } from 'react-pdf-print'
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import html2canvas from 'html2canvas';
import { getCalculations } from '../../../../../../common/policyCalculation';
import {  useSelector } from "react-redux";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import CustomDashletMixChart from '../../components/CustomDashletChart/customDashletMixChart';
import CustomDashletChart from '../../components/CustomDashletChart/';
import headerImage from '../../../../../../assets/Report/Header_CMP.jpg';
import headProfile from '../../../../../../assets/Report/Head_Profile.png';
import SpeedoMeter from '../../../../../../assets/Report/Speedometer.png';
import glossaryOfTerms from '../../../../../../assets/Report/Glossary_of_terms.png';
import ConsolidatedRegularPay from '../../../../../../assets/Report/ConsolidatedRegularPay.png';
import ConsolidatedSinglePay from '../../../../../../assets/Report/ConsolidatedSinglePay.png';
import YourAXAPortfolio from '../../../../../../assets/Report/YourAXAPortfolio.png';
import { MuiThemeProvider } from "@material-ui/core/styles";
import {RegulerFont} from './PDF-Fonts/SourceSansPro-Regular-normal';
import {Boldfont} from './PDF-Fonts/SourceSansPro-Bold-normal';
import {Italicfont} from './PDF-Fonts/SourceSansPro-Italic-normal';
import {BoldItalicfont} from './PDF-Fonts/SourceSansPro-BoldItalic-normal';

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  background:'#4472C4'
}));

function PreviewCustomReports({ open, setOpen, requestData, reportData }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const currentTheme = useTheme();

  const [dataURI, setDataURI] = useState('');
  const [hideIFrame, sethideIFrame] = useState('none');
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const currentUserData = useSelector((state) => state.config.currentUserData);
  const currentUser = pathOr([], ["data", "attributes"], currentUserData);
  const currentUserType = currentUser["type_c"];

  const [chartData, setChartData] = useState([]);
  const classes = useStyles();
  const [previewHTML,setPreviewHTML]=useState(null);
  const [imageLoading,setImageLoading]=useState([]);
  const [loading,setLoading]=useState(false);
  const ids = ['1'];
  let glossaryArray = [];
  let declaimer='';
  const title = pathOr('', ['label'], requestData);
  const unit = "pt";
  const size = "A4"; // Use A1, A2, A3 or A4
  const defaultFormat = "png"
  const orientation = "portrait"; // portrait or landscape
  const screenWidth = window.screen.width;
  const marginLeft = 40;
  const currency = pathOr('', ['allTabFilter', 0, 'currency'], requestData);
  const clientId = pathOr('', ['data', 'attributes','id'], currentUserData);
  const riskProfile = pathOr([], ['data',0,0,'riskprofilename'], reportData);
  // 11/04/23 Added DoB parameter after AXA request to use it as PDF password
  const dOB = pathOr("",["data", "attributes", "dob"],currentUserData)
  const isConsolidated = pathOr(false, ["isConsolidated"], requestData)
  const compress = isConsolidated ? true : false
  const scale = isConsolidated ? 3 : 5;
  const isPolicyLevel = pathOr('', ['isPolicyLevel'], requestData);
  const policyNum = isPolicyLevel && pathOr('', ['allTabFilter', 6, 'pname'], requestData);
  const planName = isPolicyLevel ? pathOr('', ['data', '0', '0', 'data', 'planname'], reportData) : '' ;
  console.log("current", currentUserData, reportData, requestData)
  const InsuredName = currentUserType == "Agent" ? pathOr('', ["allTabFilter", "0", "assigned_user_name", "value"] , requestData)  : '' ;
  const clientName =  InsuredName ? InsuredName : pathOr('', ['data', 'attributes','full_name'], currentUserData);
  const policyList = pathOr([], ["data"], reportData)
  const listOfPolicies = isConsolidated && policyList.length > 0 ? pathOr({}, ['data', '0'], reportData).map((item) => pathOr("", ["data", "id"], item)).filter((item) => item !== "" || item !== undefined ) : [];
  const listOfPolicyNames = isConsolidated && policyList.length > 0 ? pathOr([], ['data', '0'], reportData).map((item) => pathOr("", ["data", "planname"], item)).filter((item) => item !== "" || item !== undefined ) : [];
  // 17/04/23 Added YYYYMMDD logic for pdf password
  const password = dOB.replace(/-/g, "")
  // console.log("passsss", password)
  const fontFiles = [
    { file: "SourceSansPro-Regular-normal.ttf", name: RegulerFont, fontValue:  "SourceSansPro-Regular" },
    { file: 'SourceSansPro-Bold-normal.ttf', name: Boldfont, fontValue:  "SourceSansPro-Bold" },
    { file: 'SourceSansPro-BoldItalic-normal.ttf', name: BoldItalicfont , fontValue: "SourceSansPro-BoldItalic" },
    { file: 'SourceSansPro-Italic-normal.ttf', name: Italicfont, fontValue:  "SourceSansPro-Italic" }
  ];
  const pdf = new jsPDF({orientation, unit, size, compress ,encryption: {
    userPassword: currentUserType === "Customer" ? password : clientId,
    ownerPassword: currentUserType === "Customer" ? password : clientId,
    userPermissions: ["print", "modify", "copy", "annot-forms"]
    // try changing the user permissions granted
  }});
  // console.log("custom report pdf", open, requestData, reportData)
  const handleClose = () => {
    setOpen(false);
  };
  const componentRef = useRef(null);

  useEffect(()=>{
    // console.log("imageloading-------------", imageLoading);
    // imageLoading 0 && setTimeout(() => jsPDFDownload(1), 1000);
    jsPDFDownload(1, imageLoading);
  },[imageLoading])

  useEffect(()=>{
    let tempChartData = [];
    Object.values(pathOr([], ['data'], reportData)).map(
        function (chartData, chartKey) {
          const requestTypeObject = isConsolidated && chartData.length > 0 ? chartData.find((item) => item?.request_type) : {}
          const RowParameter = isConsolidated ? pathOr([], [chartData.length-1, "request_type"], chartData)  : pathOr([], ['query', chartKey], requestData);
          let chartType = pathOr('', ['chartType'],RowParameter);
          let callbackMethod = pathOr('', ['callbackMethod'],RowParameter);
          chartData = isConsolidated && !isNil(requestTypeObject) && !isEmpty(requestTypeObject) ? chartData.filter((item) => item !== requestTypeObject) : chartData
        
          switch (RowParameter.type) {
            case 'chart':
              // console.log(RowParameter);
              if(callbackMethod && chartType === 'mix_chart'){
                // console.log(callbackMethod, chartType);
                tempChartData[chartKey] = getCalculations(callbackMethod, {RowParameter,chartData});
              }else{
                tempChartData[chartKey] = {'request':RowParameter,'result':chartData};
              }
            break;
          }
        }
    );
   
   if(chartData.length == 0){
      setChartData(tempChartData);
    }
  },[reportData])
  
  const handleCheck = (rData, val) => {
    const returnData =  rData && rData.length > 0 && rData.some(item => val === item);
    // console.log("returrrrrrr", returnData, val, rData)
    return returnData
  }
  const isBoldOpen = useCallback((arrayLength, valueBefore = false) => {
    const isEven = arrayLength % 2 === 0;
    const result = valueBefore !== isEven;

    return result;
  });

  const insertTableIntoPDF = useCallback((
      pdf,
      tableKey,
      tableData,
      fieldName,
      requestData,
      queryDataCurrencies,
      returnDataCurrencies,
      returnIntoDataCurrencies,
      currentSection,
      nextSection,
      spacing,
      sectionWidth,
      sections,
      startY,
      startX,
      countOfGrid,
      margin,
      RowParameter,
      rowKey=0
    ) => {
      const headerData = pathOr(false, [0, 'data'], tableData) ? pathOr([], [0, 'data'], tableData) : pathOr([], [0], tableData); 
      const headerKeys = Object.keys(headerData).filter(function(item){
          return item !== 'Policy Total';
      }).map(key => pathOr(key, [key], fieldName));
      
      const headerTitle = pathOr('', ['query', tableKey, 'title'], requestData);
      let tableSize = (560/12)*pathOr(12, ['gridSize'], RowParameter);
      const headers = Object.values(fieldName).length ? headerTitle ? [
        [{
          content: pathOr([], ['query', tableKey, 'title'], requestData),
          colSpan: Object.values(fieldName).length,
        }], 
        Object.values(fieldName)] : [Object.values(fieldName)]
      :[];
      const data = [];
      const rowType = [];
      // console.log("reportData", headerKeys, tableData, requestData)
      tableData.map(elt => {
        let rowDataReport = pathOr(elt, ['data'], elt);
        data.push(Object.keys(fieldName).filter( function(item) {
          return item !== 'Policy Total';
        }).map((rowKey) =>
        rowKey == "totalunits" ? getCalculations('getUnitPriceInDecimal', (rowDataReport[rowKey]),[],pathOr('', ['allTabFilter'], requestData))
        : handleCheck(queryDataCurrencies, rowKey) 
          ? (rowKey === "CurrentUnitPrice" || rowKey === "unitprice")
            ? getCalculations('getUnitPriceInDecimalCurrency', (rowDataReport[rowKey]),[],pathOr('', ['allTabFilter'], requestData))
            // 10/04/2023 Added as per AXA request to add upto 4 decimal places in units field
            : rowKey === "UnitsHold" 
              ? getCalculations('getUnitPriceInDecimal', (rowDataReport[rowKey]),[],pathOr('', ['allTabFilter'], requestData))  
              : getCalculations('getValueWithCurrencySymbol', (rowDataReport[rowKey]),[],pathOr('', ['allTabFilter'], requestData)) 
          : handleCheck(returnDataCurrencies, rowKey) 
            ?  getCalculations('getValueOnlyInDecimalAndPercent', (rowDataReport[rowKey]),[],pathOr('', ['allTabFilter'], requestData)) 
            : handleCheck(returnIntoDataCurrencies, rowKey) 
              ? getCalculations('getValueInDecimalAndPercent', (rowDataReport[rowKey]),[],pathOr('', ['allTabFilter'], requestData)) 
              : rowDataReport[rowKey]
            ))
        
        rowType.push(pathOr('Default', ['type'], elt));
      }
      );
      // startY= pathOr('', ['type'], RowParameter)==='parent' && rowKey===0?startY-180:startY;
      let content = {
        // theme: tableKey % 2 ? 'grid' : 'striped',
        theme: 'plain',
        border: true,
        head: headers,
        body: data,

        // styles: { fillColor: [255, 0, 0] },
        columnStyles: { 0: { halign: 'left', textColor: '#000000' } }, // Cells in first column centered and green
        // margin: { left: !marginTypeLeft?tableMargin:12,right:marginTypeLeft?tableMargin:15,top:155 },
        margin: { 
          left: countOfGrid == 0 ? startX-5 : 560-tableSize,
          right: countOfGrid == 0?560-tableSize+15:15,top:155 
        },
        headStyles: {
          fillColor: '#00adc6',
          textColor: '#ffffff',
          fontSize:8,
          halign: 'center'
        },
        didParseCell: function (data) {
          var rows = data.table.body;
          data.cell.styles.lineColor = '#FFFFFF';
          data.cell.styles.lineWidth = 2;
          let isBody = pathOr('', ['section'], data);
          let isParent = pathOr('', ['row', 'index'], data);
          isParent = rowType[isParent];
          // if (data.row.index === rows.length - 1 && ) {
            // console.log("rows", data.row.index);
          // if (pathOr(false, ['query', tableKey, 'subQuery'], requestData) && isParent === 'Parent' && data.row.index !== 0 && isBody === 'body') {
          //   // console.log("rows", data.row.index, rows)
          //   data.cell.styles.fillColor = '#D3D3D3';
          //   data.cell.styles.textColor = '#000000';
          //   data.cell.styles.fontStyle = 'bold';
          //   data.cell.styles.fontSize = '10';


          // }
          data.cell.styles.font = 'SourceSansPro-Bold';
          data.cell.styles.fontStyle = 'normal';
          if(isBody === 'body' && data.row.index%2 === 0){
            data.cell.styles.font = 'SourceSansPro-Regular';
            data.cell.styles.fontStyle = 'normal';
            data.cell.styles.fillColor = '#a6e2eb';
            data.cell.styles.textColor = '#000000';
            data.cell.styles.lineColor = '#FFFFFF';
            data.cell.styles.fontSize = 8;
            data.cell.styles.lineWidth = 2;
            data.cell.styles.halign = 'center';
            if(isParent === 'Parent'){
              data.cell.styles.font = 'SourceSansPro-Bold';
              data.cell.styles.fontStyle = 'normal';
              data.cell.styles.fontSize = 8;
              data.cell.styles.halign = 'center';
              if (data.row.index === rows.length - 1) {
                data.cell.styles.fillColor = '#d7d8d8';
              }
            }
            
          }else if(isBody === 'body' && data.row.index%2 === 1){
            data.cell.styles.font = 'SourceSansPro-Regular';
            data.cell.styles.fontStyle = 'normal';
            data.cell.styles.fillColor = '#cdeef3';
            data.cell.styles.textColor = '#000000';
            data.cell.styles.lineColor = '#FFFFFF';
            data.cell.styles.fontSize = 8;
            data.cell.styles.lineWidth = 2;
            data.cell.styles.halign = 'center';
            if(isParent === 'Parent'){
              data.cell.styles.font = 'SourceSansPro-Bold';
              data.cell.styles.fontStyle = 'normal';
              data.cell.styles.fontSize = 8;
            }
            if (data.row.index === rows.length - 1) {
              data.cell.styles.fillColor = '#d7d8d8';
            }
          }
        },

        startY,
        rowPageBreak: 'avoid', // avoid breaking rows into multiple sections
        didDrawPage({ table, pageNumber, pageCount }) {
          currentSection = nextSection;
          nextSection = (nextSection % sections) + 1;

          // set left margin which will controll x position of next section
          const shift = (nextSection - 1) * (sectionWidth + spacing)
          // table.settings.margin.left = margin.left + shift;

          // if next section is not the fist, move to previous page so when
          // autoTable calls addPage() it will still be the same current page
          if (nextSection > 1) {
            pdf.setPage(pdf.internal.getCurrentPageInfo().pageNumber);
            // pdf.setPage(pdf.internal.getNumberOfPages() - 1);
          }
        }
      };
      pdf.autoTable(content);
      // pdf.addImage(imgData, 'JPEG', 5, 5);
      // activate last page for further printing
      pdf.setPage(pdf.internal.getNumberOfPages());

      // if there's remaining vertical space in page: start printing next table from the current section
      const remainingVSpace = pdf.internal.pageSize.height - margin.bottom - pdf.lastAutoTable.finalY;
      if (remainingVSpace > 10) {
        nextSection = currentSection;
        startY = pdf.lastAutoTable.finalY + 10;
      } else {
        startY = margin.top;
        if (nextSection == 1) pdf.addPage();
      }
      if(pathOr('',['helpText'],RowParameter)){
        pdf.setFontSize(7.5).setFont('SourceSansPro-Italic', 'normal').setTextColor(0,0,0);
        pdf.text(RowParameter.helpText, pathOr(20,['heldTextXPos'],RowParameter),startY, {maxWidth:560, align: pathOr('left',['helpTextAlign'],RowParameter)});
        startY += pdf.splitTextToSize(RowParameter.helpText).length*pdf.getLineHeight(); 
      }
      return {currentSection,nextSection,spacing,sectionWidth,sections,startY,startX,countOfGrid};
  },[])
  
  const jsPDFLoadImages = useCallback((chartData) => {
    setLoading(true);
    const tempImagesData = [];
    if (chartData && chartData.length > 0) {
      const imagePromises = chartData.map((_, chartKey) => {
        const chartImage = document.getElementById('chart-' + chartKey);
        return html2canvas(chartImage, {
            // scale: scale,
            compress : compress,
            unit: unit,
            // useCORS : true,
            // allowTaint: true,
        })
        .then((canvas) => {
            return new Promise((resolve) => {
              canvas.toBlob((blob) => {
                const imgData = URL.createObjectURL(blob);
                tempImagesData[chartKey] = imgData;
                resolve();
              }, 'image/png');
            });
        });
      });
      Promise.all(imagePromises).then(() => {
        setImageLoading(tempImagesData);
      });
    }
  },[chartData]);

  const jsPDFDownload = useCallback((isDownload = 1, imageLoading) => {
    if(componentRef.current) {
      html2canvas(componentRef.current,{
        // scale: scale,
        compress : compress,
        unit: unit,
        // useCORS : true,
        // allowTaint: true,
      })
      .then(() => {
          fontFiles.forEach(font => {
            pdf.addFileToVFS(font.file, font.name);
            pdf.addFont(font.file, font.fontValue, 'normal');
          });
          var today = new Date(),
          time = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear() 
          const label = pathOr('Report', ['label'], requestData);
          if(label == "Historical Returns Summary") {
              //  const imgData = canvas.toDataURL('image/png');
              //  console.log("canvassss", canvas)
              const headers = [['Portfolio Type', 'MTD', 'YTD', '1 Year', '3 Years', '5 Years', 'Since Inception']];
              const data = pathOr({}, ['data'], reportData);
              const policyType = { SP: 'Single Premium', RP: 'Regular Premium', overall: 'Consolidated Total Portfolio' };
              const dataAll = [];
              Object.keys(policyType).map(function (rowData, key) {
                let body = pathOr(pathOr([], ['overall'], data), [rowData, 'overall'], data);
                dataAll.push([policyType[rowData],
                getCalculations('getValueInDecimalAndPercent', (pathOr('NA', ['MTD'], body))),
                getCalculations('getValueInDecimalAndPercent', (pathOr('NA', ['YTD'], body))),
                getCalculations('getValueInDecimalAndPercent', (pathOr('NA', ['1YTD'], body))),
                getCalculations('getValueInDecimalAndPercent', (pathOr('NA', ['3YTD'], body))),
                getCalculations('getValueInDecimalAndPercent', (pathOr('NA', ['5YTD'], body))),
                getCalculations('getValueInDecimalAndPercent', (pathOr('NA', ['inc'], body)))]);
                Object.keys(pathOr([], [rowData], data)).filter(function (item, itemKey) {
                  return rowData !== 'overall' && item !== 'overall';
                }).map((elt, eltKey) => dataAll.push([elt,
                  getCalculations('getValueInDecimalAndPercent', (pathOr('NA', [rowData,elt,'MTD'], data))),
                  getCalculations('getValueInDecimalAndPercent', (pathOr('NA', [rowData,elt,'YTD'], data))),
                  getCalculations('getValueInDecimalAndPercent', (pathOr('NA', [rowData,elt,'1YTD'], data))),
                  getCalculations('getValueInDecimalAndPercent', (pathOr('NA', [rowData,elt,'3YTD'], data))),
                  getCalculations('getValueInDecimalAndPercent', (pathOr('NA', [rowData,elt,'5YTD'], data))),
                  getCalculations('getValueInDecimalAndPercent', (pathOr('NA', [rowData,elt,'inc'], data)))]))
             })
             
             let content = {
               border: true,
               startY: 200,
               head: headers,
               body: dataAll,
               columnStyles: { 0: { halign: 'left', textColor: '#000000' } }, // Cells in first column centered and green
               margin: { left: 10,right:10 },
               headStyles: {fillColor: '#4977b6',textColor: '#ffffff'},
               didParseCell: function (data) {
                 var rows = data.table.body;
                 const getRowData = pathOr('', [data.row.index, 'raw', 0], rows);
                 const isBody = pathOr('', ['section'], data);
  
                 if(isBody === 'body' && data.row.index%2 === 0){
                   data.cell.styles.fillColor = '#e8ebf2';
                   data.cell.styles.textColor = '#000000';
                   if(getRowData === 'Single Premium' || getRowData === 'Regular Premium' || getRowData === 'Consolidated Total Portfolio'){
                     data.cell.styles.fontStyle = 'bold';
                     data.cell.styles.fontSize = '10';
                   }
                 }else if(isBody === 'body' && data.row.index%2 === 1){
                   data.cell.styles.fillColor = '#ced5e5';
                   data.cell.styles.textColor = '#000000';
                   if(getRowData === 'Single Premium' || getRowData === 'Regular Premium' || getRowData === 'Consolidated Total Portfolio'){
                     data.cell.styles.fontStyle = 'bold';
                     data.cell.styles.fontSize = '10';
                   }
                 }
               },
             };
             pdf.autoTable(content);
          }
          else {
            const margin = {
              left: 0,
              right: 0,
              top: 193,
              bottom: 20,
            };
            const sections = parseInt(pathOr([], ['data'], reportData).length);

            // space between each section
            const spacing = 5;
            const printWidht = pdf.internal.pageSize.width - (margin.left + margin.right);
            const sectionWidth = (printWidht - ((sections - 1) * spacing)) / sections;
            // pdf.addPage();

            let currentSection;
            let nextSection = 1;
            let startY = margin.top;
            let startX = 20;
            let countOfGrid = 0;
            let tempOfX;
            let nextPageTrigger = false;
            let returnParameter;
            let tempOfPageNo
            const tData = pathOr([],["data"],reportData);
            const isConsolidated = pathOr(false, ["isConsolidated"], requestData);
            let counterForPolicy = 1;
            const processFields = (data, fundCode, type, fieldData) => {
              const obj = { fundCode, type };
              fieldData.forEach((field) => {
                if (field !== "fundCode" && data && data[field] !== undefined) {
                  obj[field] = data[field];
                }
              });
              return obj;
            };
            if(!isNil(tData) && !isEmpty(tData)) {
              Object.values(tData).map(function (tableData, tableKey) {
                const requestTypeObject = isConsolidated ? tableData.find((item) => item?.request_type) : {}
                const requestType = isConsolidated && !isNil(requestTypeObject) && !isEmpty(requestTypeObject) ? pathOr({}, ["request_type"], requestTypeObject) : {}
                tableData = isConsolidated && !isNil(requestType) && !isEmpty(requestType) ? tableData.filter((item) => item !== requestTypeObject) : tableData;
                let queryDataCurrencies = isConsolidated ? requestType['currencyFields'] : pathOr([], ['query', tableKey, 'currencyFields'], requestData);
                let returnDataCurrencies = isConsolidated ? requestType['returnFields'] :  pathOr([], ['query', tableKey, 'returnFields'], requestData);
                let returnIntoDataCurrencies = isConsolidated ? requestType['returnIntoFields'] : pathOr([], ['query', tableKey, 'returnIntoFields'], requestData);
                let fieldName = isConsolidated ? requestType['fields'] : pathOr([], ['query', tableKey, 'fields'], requestData);
                let RowParameter = isConsolidated ? requestType : pathOr([], ['query', tableKey], requestData);
                switch (RowParameter.type) {
                  case 'table':
                    if(RowParameter.name == "Policy Returns") {
                      const transformedData = [];
                      const fieldData = Object.keys(RowParameter?.fields);
                      const firstEntry = pathOr(null, ["0"], tableData)
                      if (tableData.length > 0) {
                          tableData.forEach((entry) => {
                            if( !isNil(entry) && !isEmpty(entry) ) {
                              const fundCode = pathOr("", ["0"],  Object.keys(entry))
                              const funds = pathOr({}, [fundCode,"Funds"], entry)
                              if (!isNil(funds) && !isEmpty(funds)) {
                                Object.keys(funds).forEach((fund) => {
                                  transformedData.push(processFields(funds[fund], fund, "child", fieldData));
                                });
                              }
                            }
                          });
                          if( !isNil(tableData) && !isEmpty(tableData) && !isNil(firstEntry )) {
                            const fundCode = pathOr(null, ["0"], Object.keys(firstEntry));
                            const fundData = firstEntry[fundCode];
                            transformedData.push(processFields(fundData, fundCode, "Parent", fieldData));
                          }
                          returnParameter = insertTableIntoPDF(pdf,tableKey,transformedData,fieldName,requestData,queryDataCurrencies,returnDataCurrencies,returnIntoDataCurrencies,currentSection,nextSection,spacing,sectionWidth,sections,startY,startX,countOfGrid,margin,RowParameter);
                        }
                    }
                    else{
                      returnParameter = insertTableIntoPDF(pdf,tableKey,tableData,fieldName,requestData,queryDataCurrencies,returnDataCurrencies,returnIntoDataCurrencies,currentSection,nextSection,spacing,sectionWidth,sections,startY,startX,countOfGrid,margin,RowParameter);
                    }
                    currentSection = returnParameter.currentSection ;
                    nextSection = returnParameter.nextSection ;
                    startY = returnParameter.startY;
                    // startX = returnParameter.startX;
                    // countOfGrid = returnParameter.countOfGrid;
                    countOfGrid += pathOr('12', ['gridSize'], RowParameter);
                    if(countOfGrid === 12) {
                      // startY = startY;
                      startX = 20;
                      countOfGrid = 0;
                    }
                    else {
                      startX += (560*pathOr('12', ['gridSize'], RowParameter))/12;
                    }
                    break;
                  case 'parent':
                    tempOfX = startY;
                    tempOfPageNo = pdf.internal.getCurrentPageInfo().pageNumber;
                    // console.log("Page Number", pdf.internal.getCurrentPageInfo().pageNumber);
                    tableData.forEach((tData,key) => {
                      let callbackMethod = isConsolidated ? pathOr([], ["data", "0", "callbackMethod"], requestType) : pathOr('', ['query', tableKey, 'data', key, 'callbackMethod'], requestData);
                      if(callbackMethod){
                        tData = isConsolidated ? getCalculations(callbackMethod, {...pathOr('', ['data', "0"], requestType), tableData: [ ...tData]}) : getCalculations(callbackMethod, {...pathOr('', ['query', tableKey, 'data', key], requestData), tableData : [ ...tData]});
                      }
                      let queryDataCurrencies = isConsolidated ? pathOr([], ["data", "0", "currencyFields"], requestType) : pathOr([], ['query', tableKey, 'data', key, 'currencyFields'], requestData);
                      let returnDataCurrencies = isConsolidated ? pathOr([], ["data", "0", "returnFields"], requestType) : pathOr([], ['query', tableKey, 'data', key, 'returnFields'], requestData);
                      let returnIntoDataCurrencies = isConsolidated ? pathOr([], ["data", "0", "returnIntoFields"], requestType) : pathOr([], ['query', tableKey, 'data', key, 'returnIntoFields'], requestData);
                      let fieldName = isConsolidated ? pathOr([], ["data", "0", "fields"], requestType) : pathOr([], ['query', tableKey, 'data', key, 'fields'], requestData);
                      returnParameter = insertTableIntoPDF(pdf,tableKey,tData,fieldName,requestData,queryDataCurrencies,returnDataCurrencies,returnIntoDataCurrencies,currentSection,nextSection,spacing,sectionWidth,sections,startY,startX,countOfGrid,margin,RowParameter,key);
                      currentSection = returnParameter.currentSection ;
                      nextSection = returnParameter.nextSection ;
                      startY = returnParameter.startY;
                      // startX = returnParameter.startX;
                      // countOfGrid = returnParameter.countOfGrid;
                    });
                    countOfGrid += pathOr(12, ['gridSize'], RowParameter);
                    if(countOfGrid == 12){
                      // startY = startY;
                      startX = 20;
                      countOfGrid = 0;
                    }else{
                      // console.log("Page Number2", pdf.internal.getCurrentPageInfo().pageNumber);
                      startX += (560*pathOr(12, ['gridSize'], RowParameter))/12;
                      startY = tempOfPageNo === pdf.internal.getCurrentPageInfo().pageNumber? tempOfX:margin.top-40;
                      tempOfX = returnParameter.startY;
                    }
                    break;
                  case 'header':
                    const isNewPage = pathOr(false, ["isNewPageHeader"], RowParameter);
                    let pageCurrent = pdf.internal.getCurrentPageInfo().pageNumber;
                    const remainingvertSpaceForHeader = pdf.internal.pageSize.height - margin.bottom - startY;
                    if(isNewPage && pageCurrent !== 1) {
                      startY = margin.top
                      pdf.addPage();
                      const userGreeting = `Hi **${clientName} !** Here’s your AXA ${
                        isPolicyLevel
                          ? `Policy Statement for your **${
                              isConsolidated
                                ? listOfPolicyNames && listOfPolicyNames[counterForPolicy]
                                  ? listOfPolicyNames[counterForPolicy]
                                  : ''
                                : planName
                            }** Policy **#${
                              isConsolidated
                                ? listOfPolicies && listOfPolicies[counterForPolicy]
                                  ? listOfPolicies[counterForPolicy]
                                  : ''
                                : policyNum
                            }**`
                          : `Portfolio Statement of**${
                              isPolicyLevel ? '' : currency === 'USD' ? 'US Dollar policies' : 'PH Peso Policies'
                            }** held within AXA Philippines.`}`;                      
                      const textMap = pdf.splitTextToSize(userGreeting, 280);
                      if(isConsolidated) {
                        counterForPolicy ++
                      }
                      pdf.setFillColor(254, 246, 231);
                      pdf.roundedRect(15, 148, 373, 40, 0, 0, 'F');
                      pdf.roundedRect(392, 148, 187, 40, 0, 0, 'F');
                      pdf.setTextColor(0,0,0);
                      let startXCached = 63;
                      let startYCached = textMap.length > 2 ? 159 : 165;
                      const fontSize = 9.5;
                      const lineSpacing = 12;
                      let boldOpen = false;
                      pdf.setFontSize(fontSize)
                      textMap.forEach((text, i) => {
                          if (text) {
                              const arrayOfNormalAndBoldText = text.split('**');
                              const boldStr = 'SourceSansPro-Bold';
                              const normalOr = 'SourceSansPro-Regular';
                              arrayOfNormalAndBoldText.map((textItems, j) => {
                                pdf.setFont(boldOpen ? normalOr : boldStr, "normal" );
                                  if (j % 2 === 0) {
                                    pdf.setFont(boldOpen ? boldStr : normalOr, "normal");
                                  }
                                  pdf.text(textItems, startXCached, startYCached);
                                  startXCached = startXCached + pdf.getStringUnitWidth(textItems) * fontSize;
                              });
                              boldOpen = isBoldOpen(arrayOfNormalAndBoldText.length, boldOpen);
                              startXCached = 63;
                              startYCached += lineSpacing;
                          }
                      });
                      pdf.addImage(headProfile,defaultFormat, 18, 150, 35, 35);
                    }
                    else if (remainingvertSpaceForHeader > 75) {
                      startY = startY;
                    } else {
                      startY = margin.top-40;
                      pdf.addPage();
                    }
                    pdf.setFillColor(9, 102, 172);
                    pdf.roundedRect(15, startY, 565, 30, 0, 0, 'F');
                    pdf.setTextColor(255,255,255).setFontSize(15).setFont('SourceSansPro-Bold', 'normal');
                    pdf.text(RowParameter.title, 310,startY+20,{maxWidth:900, align: 'center'});
                    let width = pdf.getTextWidth(RowParameter.title);
                    if( RowParameter.image === 'ConsolidatedRegularPay' ) {
                      pdf.addImage(ConsolidatedRegularPay,defaultFormat,(570/2) - (width/2 + 5) ,startY+3, 25, 25);
                    }
                    else if( RowParameter.image === 'ConsolidatedSinglePay' ) {
                      pdf.addImage(ConsolidatedSinglePay,defaultFormat,(570/2) - (width/2 + 5) ,startY+3, 25, 25);
                    }else{
                      pdf.addImage(YourAXAPortfolio,defaultFormat,(570/2) - (width/2 + 5) ,startY+3, 25, 25);
                    }
                    startY += 40;
                    break;
                  
                  case 'chart':
                    const remainingvertSpaceForChart = pdf.internal.pageSize.height - margin.bottom - startY;
                    const helpTextSpacing = 60;
                    const helpTextMarginTop = 10;
                    let heightOfChart = pathOr(150,['chartImageSize', 'height'],RowParameter);
                    let widthOfChart = pathOr(580,['chartImageSize', 'width'],RowParameter);
                    if (remainingvertSpaceForChart > heightOfChart + helpTextSpacing) 
                    {
                      startY = startY+0;  
                      nextPageTrigger = true;
                    } 
                    else 
                    {
                      startY = margin.top-40;
                      pdf.addPage();
                    }
                    if(pathOr('', ['callbackMethod'],RowParameter) && pathOr('', ['callbackMethod'],RowParameter) === 'portfolioLast5Year') {
                      if(imageLoading[tableKey] && imageLoading[tableKey]?.length > 0) {
                        pdf.addImage(imageLoading[tableKey], defaultFormat, startX, startY, widthOfChart,heightOfChart);
                      }
             
                      // startY += heightOfChart+10;
                      countOfGrid += pathOr(12, ['gridSize'], RowParameter);
                      if(countOfGrid == 12){
                        // startY += heightOfChart+10;
                        startX = 20;
                        countOfGrid = 0;
                        startY = tempOfX && tempOfX > heightOfChart ? tempOfX : startY+heightOfChart+10;
                        tempOfX = 0;
                      }
                      else{
                        startX += (560*pathOr('12', ['gridSize'], RowParameter))/12;
                      }
                      if(pathOr('',['helpText'],RowParameter)){
                        pdf.setFontSize(7.5).setFont('SourceSansPro-Italic', 'normal').setTextColor(0,0,0);
                        pdf.text(RowParameter.helpText, pathOr(20,['heldTextXPos'],RowParameter),startY, {align: pathOr('left',['helpTextAlign'],RowParameter)});
                        startY += pdf.splitTextToSize(RowParameter.helpText).length*pdf.getLineHeight(); 
                      }
                    }
                    else{
                      if(RowParameter.text){
                        pdf.setFontSize(8).setTextColor(0,0,0);
                        pdf.text(RowParameter.text, startX,startY+5,{maxWidth:150, align: 'left'});
                        // startY=startY+5;
                      }
                      if(imageLoading[tableKey] && imageLoading[tableKey]?.length > 0) {
                        pdf.addImage(imageLoading[tableKey], defaultFormat, startX, startY+10, widthOfChart, heightOfChart);
                      }
                      countOfGrid += pathOr(12, ['gridSize'], RowParameter);
                      if(countOfGrid == 12)
                      {
                        // startY += heightOfChart+10;
                        startX = 20;
                        countOfGrid = 0;
                        if(nextPageTrigger)
                        {
                          startY = startY+heightOfChart+helpTextMarginTop
                        }
                        else
                        {
                          startY = tempOfX && tempOfX > heightOfChart ? tempOfX : startY+heightOfChart+10;
                          tempOfX = 0;
                        }
                      }
                      else
                      {
                        startX += (560*pathOr('12', ['gridSize'], RowParameter))/12;
                      }
                      
                      if(pathOr('',['helpText'],RowParameter))
                      {
                        //Code added by Rishabh for the change of help Text position in PDF, commented as per client requirement. Same parameter 'heldTextYPos' added in User preference if in future any requirement related to Help Text positioning
  
                        // if(pathOr('',['heldTextYPos'], RowParameter))
                        // {
                        //   pdf.setFontSize(8).setFont('SourceSansPro-Italic', 'normal').setTextColor(0,0,0);
                        //   pdf.text(RowParameter.helpText, pathOr(20,['heldTextXPos'],RowParameter),pathOr('',['heldTextYPos'], RowParameter), {renderingMode:'fill',maxWidth:560, align: pathOr('left',['helpTextAlign'],RowParameter)});
                        //   startY += pathOr('',['helpTextYPos'], RowParameter);
                        // }
                          pdf.setFontSize(8).setFont('SourceSansPro-Italic', 'normal').setTextColor(0,0,0);
                          pdf.text(
                            RowParameter.helpText,
                            pathOr(20,['heldTextXPos'],RowParameter),
                            startY+helpTextMarginTop, 
                            {
                              renderingMode:'fill',
                              maxWidth:560,
                              align: pathOr('left',['helpTextAlign'],RowParameter)
                            }
                          );
                          startY += pdf.splitTextToSize(RowParameter.helpText).length*pdf.getLineHeight(); 
                      }
                    }
                    break;
                  
                  case 'glossaryOfTerms':
                    glossaryArray = tableData;
                    if(isConsolidated) {
                      const glossaryObject = pathOr([], ["query"], requestData).find((item) => item.type === "glossaryOfTerms")
                      declaimer = pathOr("", ["declaimer"], glossaryObject)
                    }
                    else {
                      declaimer = pathOr('', ['query', tableKey, 'declaimer'], requestData);
                    }
                    break;
                  
                }
              })
            }
          }
          let counterForPolicy = 0
          let pageCount = pdf.internal.getNumberOfPages(); //Total Page Number
          // let chartHeader = title + ` | ${currency == 'USD'?'US Dollar Policies':'PH Peso Policies'}`;
          let currencyHeader = ( currency === 'USD') ? 'US Dollar Policies' : 'PH Peso Policies';
          let chartHeader = title + ` | ` + currencyHeader;
          let headerFontSize =  (262/chartHeader.length) * 2.70;
          let options = { year: 'numeric', month: 'long', day: 'numeric' };
          let currDate  = new Date(today.getFullYear(), today.getMonth(), 0);
          
          currDate = currDate.toLocaleDateString("en-US", options);
          const userGreeting = `Hi **${clientName} !** Here’s your AXA ${
            isPolicyLevel
              ? `Policy Statement for your **${
                  isConsolidated
                    ? listOfPolicyNames && listOfPolicyNames[counterForPolicy]
                      ? listOfPolicyNames[counterForPolicy]
                      : ''
                    : planName
                }** Policy **#${
                  isConsolidated
                    ? listOfPolicies && listOfPolicies[counterForPolicy]
                      ? listOfPolicies[counterForPolicy]
                      : ''
                    : policyNum
                }**`
              : `Portfolio Statement of**${
                  isPolicyLevel ? '' : currency === 'USD' ? 'US Dollar policies' : 'PH Peso Policies'
                }** held within AXA Philippines.`}`;
          
          let textMap = pdf.splitTextToSize(userGreeting, 280);
          let riskProfileText = `Your risk profile is:`;
          let riskProfileTextValue = `${riskProfile}`;
          for(let i = 0; i < pageCount; i++) { 
            pdf.setPage(i); 
            let pageCurrent = pdf.internal.getCurrentPageInfo().pageNumber; //Current Page
            pdf.addImage(headerImage, defaultFormat, 0, 0, 595, 143);
            pdf.setFont('SourceSansPro-Regular', 'normal').setTextColor(255,255,255);
            pdf.setFontSize(headerFontSize);
            pdf.text(chartHeader, 280,85,{maxWidth:300, align: 'center'});
            pdf.setFontSize(9.5).setFont('SourceSansPro-Bold', 'normal');
            pdf.text(`Your AXA Variable ${isPolicyLevel ? 'Policy' : 'Unit Linked Portfolio'} Information`, 25,117);
            pdf.setFont('SourceSansPro-BoldItalic', 'normal');
            pdf.text(`As of ${currDate}`, 25,132);
            // console.log(pdf.getFont());
            if(pageCurrent == 1){
  
              pdf.setFillColor(254, 246, 231);
              pdf.roundedRect(15, 148, 373, 40, 0, 0, 'F');
              pdf.roundedRect(392, 148, 187, 40, 0, 0, 'F');
              pdf.setTextColor(0,0,0);
              let startXCached = 63;
              let startYCached = textMap.length > 2 ? 159 : 165;
              const fontSize = 9.5;
              const lineSpacing = 12;
              let boldOpen = false;
              textMap.forEach((text, i) => {
                  if (text) {
                      const arrayOfNormalAndBoldText = text.split('**');
                      const boldStr = 'SourceSansPro-Bold';
                      const normalOr = 'SourceSansPro-Regular';
                      arrayOfNormalAndBoldText.map((textItems, j) => {
                        pdf.setFont(boldOpen ? normalOr : boldStr, "normal" );
                          if (j % 2 === 0) {
                            pdf.setFont(boldOpen ? boldStr : normalOr, "normal");
                            
                          }
                          pdf.text(textItems, startXCached, startYCached);
                          startXCached = startXCached + pdf.getStringUnitWidth(textItems) * fontSize;
                      });
                      boldOpen = isBoldOpen(arrayOfNormalAndBoldText.length, boldOpen);
                      startXCached = 63;
                      startYCached += lineSpacing;
                  }
              });
              pdf.addImage(headProfile,defaultFormat, 18, 150, 35, 35);
            }
            
          }
          // PDF Header End

          // Glossary of terms start

          pdf.addPage();
          pdf.setFillColor( 9, 102, 172 );
          pdf.roundedRect(15, 20, 565, 30, 0, 0, 'F');
          pdf.setFontSize(20).setFont('SourceSansPro-Bold', 'normal').setTextColor(255,255,255);
          pdf.addImage(glossaryOfTerms,defaultFormat, 190,23, 25, 25);
          pdf.text('Glossary of terms', 310,40,{maxWidth:300, align: 'center'});
          let GstartY = 80;
          glossaryArray.forEach((eachItem,index) => {
            if((GstartY+((eachItem['description'].length/65)*15)+15) > 850){
              pdf.addPage();
              pdf.setFillColor( 9, 102, 172 );
              pdf.roundedRect(15, 20, 565, 30, 0, 0, 'F');
              pdf.setFontSize(20).setFont('SourceSansPro-Bold', 'normal').setTextColor(255,255,255);
              pdf.addImage(glossaryOfTerms,defaultFormat, 190,23, 25, 25);
              pdf.text('Glossary of terms', 310,40,{maxWidth:300, align: 'center'});
              GstartY = 80;
            }
            pdf.setFontSize(9).setFont('SourceSansPro-Regular', 'normal').setTextColor(0,0,0);
            let textMapDecription = pdf.splitTextToSize(eachItem.description, 300);
            pdf.text(eachItem.description, 270,GstartY,{maxWidth:300, align: 'left'});
            pdf.setFontSize(15).setFont('SourceSansPro-Bold', 'normal').setTextColor(4, 114, 147);
            let textMapTitle = pdf.splitTextToSize(eachItem.title, 200);
            pdf.text(eachItem.title, 220,GstartY+(textMapDecription.length*9)/2 - (textMapTitle.length > 1 ? textMapTitle.length*6: 0),{maxWidth:200, align: 'right'});
            pdf.setLineWidth(2).setTextColor(163, 163, 163);
            pdf.line(245, GstartY-10, 245, GstartY+(textMapDecription.length*9), 'F');
            GstartY += (textMapDecription.length*12)+15;
          });
          if(GstartY > 710){
            pdf.addPage();
            pdf.setFillColor( 9, 102, 172 );
            pdf.roundedRect(15, 20, 565, 30, 0, 0, 'F');
            pdf.setFontSize(20).setFont('SourceSansPro-Bold', 'normal').setTextColor(255,255,255);
            pdf.addImage(glossaryOfTerms,defaultFormat, 190,23, 25, 25);
            pdf.text('Glossary of terms', 310,40,{maxWidth:300, align: 'center'});
          }
          pdf.setFillColor(234, 235, 235);
          pdf.roundedRect(15, 730, 570, 100, 0, 0, 'F');
          pdf.setFontSize(9).setFont('SourceSansPro-Regular', 'normal').setTextColor(0,0,0);
          pdf.text(declaimer, 20,750,{maxWidth:560, align: 'left'});
          // Glossary of terms end
          // modified by deep k on 25-01-2022 to preview and download a pdf start.
          if(isDownload !== 1 && screenWidth > 750){
            const dataURI = pdf.output('dataurlstring');
            if(dataURI !== undefined && dataURI !== '' ) {
              setDataURI(dataURI);
              sethideIFrame('block');
            }
          }
          if(isDownload === 1){
            pdf.save(title.replace(/\s+/g, '_') +'-'+ time + ".pdf");
          }
          // modified by deep k on 25-01-2022 to preview and download a pdf end.
          setLoading(false);
        }).catch((e)=>console.log(e));
    }
  },[imageLoading])
  
  return (
    <MuiThemeProvider theme={getMuiTheme(currentTheme)}>
    <div>

      <Dialog open={open} onClose={handleClose} className={classes.reportDialog} style={{overflow:'hidden !important'}}  fullWidth={true} maxWidth="sm"  >
        <DialogTitle>{pathOr('', ['label'], requestData)}</DialogTitle>
        
        <DialogContent style={{display: hideIFrame,height:'550px',overflow:'hidden'}}>
          <Grid item xs={12}>
            <iframe width='100%' height='550' id="PDF-Preview"  src={dataURI}/>
          </Grid>
          
        </DialogContent>
   
        <DialogActions>
          {loading?<Button disabled={true}>Loading...</Button>:<Button onClick={() => jsPDFLoadImages(chartData)}>Download</Button>}
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
        <div 
          ref = {componentRef}
          style = {{margin:'auto',height:'0px',overflow:'hidden',maxWidth: '200px'}} 
          id="divToPrint" 
          className="card" 
        >
          <Grid container spacing={2}>
            {
              chartData && chartData.map((chartValue, chartKey) => {
                if(chartValue.chartType == 'mix_chart' && pathOr('', ['callbackMethod'], chartValue)){
                  return <div key={"chart-"+chartKey} id={"chart-"+chartKey}>
                    <CustomDashletMixChart key={chartKey} data={chartValue} fullData={chartValue} subChartShow={false} isPdf={true} id = {'chart-'+chartKey}
                    />
                  </div>
                }else{
                  return <div key={"chart-"+chartKey} id={"chart-"+chartKey}>
                  <CustomDashletChart key={chartKey} data={chartValue['request']} fullData={chartValue['request']} result={chartValue['result']} isPdf={true} id = {'chart-'+chartKey} 
                  />
                  </div>
			
                }
              })
            }
            {/* {chartData !== undefined ?<CustomDashletMixChart key={'123'} data={chartData} fullData={chartData} subChartShow={false}/>:<></>} */}
          
            
          </Grid>
        </div>
      </Dialog>
     
    </div>
    </MuiThemeProvider>
  );
}

export default React.memo(PreviewCustomReports)